import * as t from "io-ts";
import nullable from "./nullable";
import { cargoTypeT } from "./types";
export const priceRequested = t.strict({
    type: t.literal("priceRequested"),
    matchId: t.string,
    cargoOwnerId: t.string,
    routeOwnerId: t.string,
});
const userT = t.union([
    t.strict({
        userType: t.literal("DRIVER"),
        driverId: t.string,
    }),
    t.strict({
        userType: t.literal("AI"),
    }),
]);
const positionT = t.strict({
    lon: t.number,
    lat: t.number,
    accuracy: t.number,
});
const updateDriverNoteEventT = t.strict({
    type: t.literal("CARGO_NOTE_EDITED"),
    note: t.string,
});
export const updateDriverEventT = updateDriverNoteEventT;
export const createDriverEvents = ({ dateTime, decimal, }) => {
    const commonEventData = t.strict({
        id: t.string,
        createdBy: userT,
        createdAt: dateTime,
        position: nullable(positionT),
        time: dateTime,
    });
    const plannedLocationInnerT = nullable(t.strict({
        position: t.strict({
            lon: t.number,
            lat: t.number,
        }),
        place: nullable(t.string),
        country: nullable(t.string),
        city: nullable(t.string),
        postcode: nullable(t.string),
        address: nullable(t.string),
    }));
    const plannedLocationT = t.strict({
        cargoId: t.string,
        stopId: t.string,
        plannedLocation: plannedLocationInnerT,
    });
    const driverLoggedInEventT = t.intersection([
        commonEventData,
        t.strict({
            type: t.literal("DRIVER_LOGGED_IN"),
            routeId: t.string,
        }),
    ]);
    const tripEventT = t.intersection([
        commonEventData,
        t.strict({
            type: t.union([t.literal("TRIP_STARTED"), t.literal("TRIP_ENDED")]),
            note: nullable(t.string),
            odometer: t.number,
        }),
    ]);
    const lastEditedT = t.strict({
        by: t.string,
        at: dateTime,
        value: dateTime,
    });
    const cargoCollectedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_COLLECTED"),
            lm: decimal,
            lastEdited: nullable(lastEditedT),
        }),
    ]);
    const cargoDeliveredEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_DELIVERED"),
            lm: decimal,
            lastEdited: nullable(lastEditedT),
        }),
    ]);
    const driverArrivedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("DRIVER_ARRIVED"),
            lastEdited: nullable(lastEditedT),
        }),
    ]);
    const driverDepartedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("DRIVER_DEPARTED"),
            lastEdited: nullable(lastEditedT),
        }),
    ]);
    const cargoNoteAddedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_NOTE_ADDED"),
            note: t.string,
        }),
    ]);
    const cargoNoteEditedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_NOTE_EDITED"),
            noteId: t.string,
            note: t.string,
        }),
    ]);
    const cargoNoteDeletedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_NOTE_DELETED"),
            noteId: t.string,
        }),
    ]);
    const cargoInvoiceReferenceAddedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_INVOICE_REF_ADDED"),
            ref: t.string,
        }),
    ]);
    const cargoInvoiceRefEditedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_INVOICE_REF_EDITED"),
            invoiceRefId: t.string,
            ref: t.string,
        }),
    ]);
    const cargoInvoiceRefDeletedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_INVOICE_REF_DELETED"),
            invoiceRefId: t.string,
        }),
    ]);
    const cargoWeightAddedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_WEIGHT_ADDED"),
            weight: decimal,
        }),
    ]);
    const cargoWeightEditedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_WEIGHT_EDITED"),
            weightId: t.string,
            weight: decimal,
        }),
    ]);
    const cargoWeightDeletedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_WEIGHT_DELETED"),
            weightId: t.string,
        }),
    ]);
    const cargoVolumeAddedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_VOLUME_ADDED"),
            cubicMeters: decimal,
        }),
    ]);
    const cargoVolumeEditedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_VOLUME_EDITED"),
            volumeId: t.string,
            cubicMeters: decimal,
        }),
    ]);
    const cargoVolumeDeletedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_VOLUME_DELETED"),
            volumeId: t.string,
        }),
    ]);
    const driverUpdateCargoStopEventDataT = t.strict({
        date: nullable(dateTime),
        stopTime: nullable(t.string),
        place: nullable(t.any),
        lm: nullable(decimal),
        cargoType: nullable(cargoTypeT),
        description: nullable(t.string),
        clientId: nullable(t.string),
    });
    const driverUpdateCargoStopEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("DRIVER_CARGO_STOP_UPDATE"),
            from: driverUpdateCargoStopEventDataT,
            to: driverUpdateCargoStopEventDataT,
        }),
    ]);
    const cargoDocumentAddedEventT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("CARGO_DOCUMENT_ADDED"),
            documentType: t.string,
            url: t.string,
            urlNew: t.string,
            deletedAt: nullable(dateTime),
        }),
    ]);
    const driverCargoTimeTrackingStartT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("DRIVER_CARGO_TIME_TRACKING_STARTED"),
            cargoId: t.string,
        }),
    ]);
    const driverCargoTimeTrackingPauseT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("DRIVER_CARGO_TIME_TRACKING_PAUSED"),
            cargoId: t.string,
        }),
    ]);
    const driverCargoTimeTrackingResumeT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("DRIVER_CARGO_TIME_TRACKING_RESUMED"),
            cargoId: t.string,
        }),
    ]);
    const driverCargoTimeTrackingStopT = t.intersection([
        commonEventData,
        plannedLocationT,
        t.strict({
            type: t.literal("DRIVER_CARGO_TIME_TRACKING_STOPPED"),
            cargoId: t.string,
        }),
    ]);
    const driverEventT = t.union([
        driverLoggedInEventT,
        tripEventT,
        cargoCollectedEventT,
        cargoDeliveredEventT,
        cargoNoteAddedEventT,
        cargoNoteEditedEventT,
        cargoNoteDeletedEventT,
        cargoDocumentAddedEventT,
        cargoWeightAddedEventT,
        cargoWeightEditedEventT,
        cargoWeightDeletedEventT,
        cargoVolumeAddedEventT,
        cargoVolumeEditedEventT,
        cargoVolumeDeletedEventT,
        cargoInvoiceReferenceAddedEventT,
        cargoInvoiceRefEditedEventT,
        cargoInvoiceRefDeletedEventT,
        driverArrivedEventT,
        driverDepartedEventT,
        driverUpdateCargoStopEventT,
        driverCargoTimeTrackingStartT,
        driverCargoTimeTrackingPauseT,
        driverCargoTimeTrackingResumeT,
        driverCargoTimeTrackingStopT,
    ]);
    const driverEventsT = t.array(driverEventT);
    return {
        driverEventT,
        cargoWeightAddedEventT,
        cargoWeightEditedEventT,
        cargoWeightDeletedEventT,
        cargoVolumeAddedEventT,
        cargoVolumeEditedEventT,
        cargoVolumeDeletedEventT,
        cargoInvoiceReferenceAddedEventT,
        cargoCollectedEventT,
        cargoDeliveredEventT,
        driverLoggedInEventT,
        driverEventsT,
        plannedLocationInnerT,
        driverUpdateCargoStopEventT,
        driverCargoTimeTrackingStartT,
        driverCargoTimeTrackingPauseT,
        driverCargoTimeTrackingResumeT,
        driverCargoTimeTrackingStopT,
    };
};
//# sourceMappingURL=events.js.map